import React from "react";
import {
  Box,
  Card,
  Divider,
  Group as MGroup,
  SegmentedControl,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { ValidationDiffTable } from "../components/ValidationDiffTable";
import { formatShortDate } from "../globalUtils";
import {
  selectSpecifiedArticlesValidation,
  selectSpecifiedArticlesResponsibilities,
  selectShouldShowSpecifiedArticlesSegmented,
  selectRfpSpecifiedArticlesResponsibility,
  selectSpecifiedArticlesDiffItems,
  selectSpecifiedArticlesMatchRatePct,
  selectSpecifiedArticlesValidatedAt,
} from "../DesignTab/ModuleBars/RFPBarSelectors";
import { setRfpSpecifiedArticlesResponsibilityInRedux } from "../DesignTab/designSlice";

export const DrofusSpecifiedArticlesDiffAllResponsibilities: React.FC = () => {
  const dispatch = useAppDispatch();

  const specified = useAppSelector(selectSpecifiedArticlesValidation);
  const responsibilities = useAppSelector(selectSpecifiedArticlesResponsibilities);
  const showSegmented = useAppSelector(selectShouldShowSpecifiedArticlesSegmented);

  const activeResponsibility = useAppSelector(selectRfpSpecifiedArticlesResponsibility);

  const diffs = useAppSelector(selectSpecifiedArticlesDiffItems);
  const matchRatePct = useAppSelector(selectSpecifiedArticlesMatchRatePct);
  const validatedAt = useAppSelector(selectSpecifiedArticlesValidatedAt);

  if (!specified) {
    return (
      <Card withBorder radius="md" w="100%">
        <Text>Ingen spesifiserte artikler-validering funnet for rommet</Text>
      </Card>
    );
  }

  return (
    <Card
      withBorder
      radius="md"
      w="100%"
      h="calc(100% - 175px)"
      style={{ display: "flex", flexDirection: "column", minHeight: 0 }}
    >
      <Stack gap="xs" align="flex-start" style={{ flex: "0 0 auto" }}>
        <Box w="100%">
          <MGroup justify="space-between" align="center">
            {showSegmented ? (
              <SegmentedControl
                value={activeResponsibility ?? ""}
                onChange={(value) => {
                  const next = value ? String(value) : null;
                  dispatch(setRfpSpecifiedArticlesResponsibilityInRedux(next));
                }}
                data={[
                  { value: "", label: "Alle" },
                  ...responsibilities.map((r) => ({ value: r, label: r })),
                ]}
                radius="xl"
                size="sm"
                color="blue"
                transitionDuration={120}
              />
            ) : (
              <Text size="sm" c="dimmed">
                Ingen ansvarskoder funnet (viser total)
              </Text>
            )}

            {matchRatePct != null && validatedAt != null && (
              <Stack gap={0} align="flex-end" style={{ minWidth: 0 }}>
                <MGroup gap="xs">
                  <Text size="xs" c="dimmed">
                    Treffsikkerhet
                  </Text>
                  <Text size="xs" fw={600}>
                    {Number(matchRatePct).toFixed(1)} %
                  </Text>
                </MGroup>

                <Tooltip label={validatedAt} position="bottom-end" withArrow>
                  <Text size="xs" c="dimmed">
                    Sist validert {formatShortDate(validatedAt)}
                  </Text>
                </Tooltip>
              </Stack>
            )}
          </MGroup>
        </Box>
      </Stack>

      <Divider my="xs" />

      <ValidationDiffTable diffItems={diffs} standardCountHeaderName="Antall i RFP" />
    </Card>
  );
};
